import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../../utils/ajax'

class faultDContentStore {
  @observable loading
  @observable content
  @observable title
  @observable carSeriesName


  constructor () {
    this.loading = false;
    this.content = [];
    this.title = ''
    this.carSeriesId = ''
    this.carSeriesName = ''
  }
  @action
  init = async(carSeriesId,level4) =>{
    runInAction(()=>{
      this.loading = true;
      this.carSeriesId = carSeriesId
    })
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCatalog/${level4}`)
    if(res && res.status === 0){
      runInAction(()=>{
        this.loading = false
      })
      return
    }
    const carSeries = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCarseriesCatalog/id/${carSeriesId}`)
    if(carSeries && carSeries.status === 0){
      runInAction(()=>{
        this.loading = false
      })
      return
    }

    const content = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisInfo/findOneCatalogIdAndState/${level4}/2`)
    if(content && content.status === 0){
      runInAction(()=>{
        this.loading = false
      })
      return
    }
    runInAction(()=>{
      this.title = res.defaultName;
      this.carSeriesName = carSeries.carseriesName
      this.content = content
      this.loading = false;
    })
  }
}
export default new faultDContentStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/faultDiagnosis/main/Content/store.js